import "./App.scss";
// Import Routes all
import React from "react";
import MyRouter from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import AppModal from "../src/components/popup";
import RedirectMiddleware from "./components/RedirectMiddleware";

function App() {
  return (
    <>
      <BrowserRouter>
        {/* Wrap your entire routing system with RedirectMiddleware */}
        <RedirectMiddleware>
          <MyRouter />
        </RedirectMiddleware>
      </BrowserRouter>
      <div>
        {/* Other content of your app */}
        <AppModal />
      </div>
    </>
  );
}

export default App;
